"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SQLParser = void 0;
const tslib_1 = require("tslib");
const SQLParser_1 = tslib_1.__importDefault(require("./SQLParser"));
exports.SQLParser = SQLParser_1.default;
//# sourceMappingURL=index.js.map